import React from "react";
import { Switch, Route, BrowserRouter } from "react-router-dom";
import { PrivateApp } from "../Components/Templates";

import { PublicTemplate } from "../Pages/Public/Template";

const Routes = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path='/auth'>
          <PublicTemplate/>
        </Route>
        <Route path='/'>
          <PrivateApp  />
        </Route>
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
